import React from 'react';
import { VideoQuality } from 'livekit-client';
import { SingleValue } from 'react-select';
import { SelectOption } from '../Select/types';
import { ControlSelect } from '../Select/Select';
import { ControlSelectView, ControlSelectViewLabel } from './view';

type Props = {
    label: string;
    onChange(option: SingleValue<SelectOption>): void;
    value: SelectOption['value'];
};

export const QualitySelector = ({ label, onChange, value }: Props) => {
    const options: SelectOption[] = [
        {
            value: VideoQuality.LOW,
            label: 'Low',
        },
        {
            value: VideoQuality.MEDIUM,
            label: 'Medium',
        },
        {
            value: VideoQuality.HIGH,
            label: 'High',
        },
    ];

    return (
        <ControlSelectView>
            {label && <ControlSelectViewLabel> {label} </ControlSelectViewLabel>}
            <ControlSelect value={value} options={options} optionSelected={onChange} />
        </ControlSelectView>
    );
};
